import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
/*Fix this*/
import axios from "axios";
import "../../profiles/profileComponents/ProfileSettings.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    minWidth: 120,
  },
}));
export default function AgentNotes(props) {
  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
  };
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [agentNotes, setAgentNotes] = useState();

  function UpdateNotes() {
    let AgentRequestDTO = {
      prmIdAgent: props.IdAgent,
      prmNotes: agentNotes.notes1,
      prmNotesEmpty: agentNotes.notes1 !== "" ? false : true,
      prmIP: userInfo.IP ?? '10.0.0.1',
      prmPhoneLine : -1,
      prmIdUser: userInfo.IdUser

    };
    axios({
      method: "post",
      //url: 'https://localhost:44337/api/Agent/AgentNotesMaintenance',
      url: process.env.REACT_APP_API2_URL + "/Agent/AgentNotesMaintenance",
      data: AgentRequestDTO,
    }).then((response) => {
      if (response.data === "-1") {
        // alert("Data Successfully Updated");
      }
      console.log("response", response);
    });
  }

  const NotesValues = () => {
    console.log("USER INFO ======>", userInfo);
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/Agent/Agent_GetNotes?idAgent=" +
        props.IdAgent,
      /*  REPLACE WITH SELECT DATA */
    })
      .then((response) => response)
      .then((data) => {
        setAgentNotes(data.data);
        console.log("CHARTING VISITOR VALUES========>", data.data);
      });
  };

  useEffect(() => {
    NotesValues();
  }, [props.IdAgent]);

  const handleUpdate = (event, key, value) => {
    props.AgentInfo[key] = event ? event.target.value : value;
    UpdateNotes(props.AgentInfo);
  };

  const handleChange = (event, key, value) => {
    setAgentNotes({
      ...agentNotes,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setAgentNotes(props.AgentInfo);
  }, [props.AgentInfo]);

  return (
    <React.Fragment>
      {agentNotes && (
        <div className="vertical-options">
          <TextField
            className="flex-1"
            size="small"
            type="text"
            label="Notes"
            value={agentNotes.notes1}
            onChange={(event) => handleChange(event, "notes1")}
            onBlur={(event) => UpdateNotes()}
            variant="outlined"
            multiline
            minRows={4}
          />
        </div>
      )}
    </React.Fragment>
  );
}
